exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".o-multiselect-menu{max-height:320px;overflow-y:auto;min-width:240px;max-width:340px}.o-multiselect-menu .custom-control-label{white-space:normal;word-break:break-word}", ""]);

// exports
